import { ListViewFilters } from '@razorpay/blade/components';
import React from 'react';
import StatusFilter from './StatusFilter';
import { statusFilters } from 'components/SalaryComponents/constants';

const SalaryComponentListViewFiltersComponent = ({
  counts,
}: {
  counts?: Record<keyof typeof statusFilters, number>;
}) => {
  return (
    <>
      <ListViewFilters quickFilters={<StatusFilter counts={counts} />}></ListViewFilters>
    </>
  );
};

export default SalaryComponentListViewFiltersComponent;
